import React, { useState } from 'react';
import EventCard from '../shared/EventCard/EventCard';
import EventModal from '../forum/EventProgram/EventModal/EventModal';

// Speaker page events island: one shared EventCard for both lists, split into two
// sections — "Speaking" (upcoming) and "Past". The cards carry the year themselves,
// so the lists are flat here (the per-year dividers stay on the chapter page).
// The speaker column is hidden (it's the speaker's own page). Chapter events open
// the rich modal; chapter-less workshops link straight to the workshop page.
const SpeakerEvents = ({ upcoming = [], past = [] }) => {
    const [selected, setSelected] = useState(null);

    const renderCard = (ev) => (ev.chapter
        ? <EventCard key={ev.id} event={ev} hideSpeakers onActivate={setSelected} />
        : <EventCard key={ev.id} event={ev} hideSpeakers href={ev.event_url} />
    );

    // Reuse the shared year-divider styling (.agenda-year) for the section label.
    const section = (label, events) => events.length > 0 && (
        <>
            <div className="agenda-year"><span>{label}</span></div>
            <div className="agenda-card-list">{events.map(renderCard)}</div>
        </>
    );

    return (
        <>
            {section('Speaking', upcoming)}
            {section('Past', past)}
            <EventModal event={selected} onClose={() => setSelected(null)} />
        </>
    );
};

export default SpeakerEvents;
